import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import { setCredentials } from '../../store/slices/authSlice';
import { usersAPI } from '../../services/api';
import { LoadingPage } from '../../components/common/UI';

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = searchParams.get('accessToken');
    const refreshToken = searchParams.get('refreshToken');

    if (!accessToken || !refreshToken) {
      toast.error('Authentication callback failed. Tokens missing.');
      navigate('/login');
      return;
    }

    // Save tokens initially
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);

    // Fetch profile to get role and user details
    const fetchUser = async () => {
      try {
        const { data } = await usersAPI.get('me');
        const user = data.data || data;
        dispatch(setCredentials({ user, accessToken, refreshToken }));
        toast.success('Successfully signed in with Google!');

        const role = user?.role;
        if (['super_admin', 'admin', 'moderator'].includes(role)) {
          navigate('/admin');
        } else if (['business_owner', 'business_staff'].includes(role)) {
          navigate('/business');
        } else {
          navigate('/');
        }
      } catch (err) {
        // Fallback default user structure if profile fetch fails
        const fallbackUser = { id: 1, role: 'customer' };
        dispatch(setCredentials({ user: fallbackUser, accessToken, refreshToken }));
        navigate('/');
      }
    };

    fetchUser();
  }, [searchParams, dispatch, navigate]);

  return <LoadingPage />;
}
